import AboutModal from './AboutModal.json';
import Buttons from './Buttons.json';
import CineDialog from './CineDialog.json';
import Common from './Common.json';
import Header from './Header.json';
import UserPreferencesModal from './UserPreferencesModal.json';
import ViewportDownloadForm from './ViewportDownloadForm.json';

export default {
  'ja-JP': {
    AboutModal,
    Buttons,
    CineDialog,
    Common,
    Header,
    UserPreferencesModal,
    ViewportDownloadForm,
  },
};
